function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 2a2 2 0 014 0v42h42a2 2 0 110 4H2a2 2 0 01-2-2V2zm16.12 18.7a1.36 1.36 0 011.97 0l7.4 7.72 7.64-7.99-2.57-2.68c-1.32-1.38-.39-3.74 1.48-3.74h8.81c.77 0 1.4.65 1.4 1.46v9.2c0 1.95-2.26 2.92-3.58 1.55l-2.57-2.7-9.63 10.05c-.54.57-1.43.57-1.97 0l-7.4-7.72-4.51 4.72c-.55.57-1.43.57-1.98 0l-.98-1.03a1.5 1.5 0 010-2.06l6.49-6.78z"
})));